import * as React from "react";
const joinData = (values) => values.filter((v) => !!v).join(" ");
const SummaryItem = (value) => {
  if (!value || Array.isArray(value) && value.every((val) => !val)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("span", null, joinData(Array.isArray(value) ? value : [value]));
};
export {
  SummaryItem as default
};
//# sourceMappingURL=SummaryItem.js.map
